module.exports = __webpack_public_path__ + "img/PC_03.8f99ca1b.jpg";